/* eslint-disable react/prop-types */
import React from "react";
import { Navigate } from "react-router-dom";
import LocalStorageService from "../services/storage";

const ProtectedRoute = ({ component, allowedRoles = [] }) => {
  const isAuthenticated = !!localStorage.getItem('token');

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  const localStorageService = LocalStorageService();
  const userInfo = localStorageService.getUserInfo();
  const userRole = userInfo?.user_role;

  // Verifica se o usuário tem permissão
  const hasPermission = allowedRoles.includes(userRole);

  if (!hasPermission) {
    return <Navigate to="/unauthorized" />;
  }

  return React.isValidElement(component) ? component : React.createElement(component);
};

export default ProtectedRoute;
